import { versionedHttpCollection } from "us.helper/http/collection";
import ServiceConfig from "service.config.js";

export default {
  notes: {
    save: (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.post(
            "uscservice",
            "notes",
            params?.data,
            ServiceConfig()[`uscservice`]["domainMessage.note"]
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
  },

  domainMessage: {
    getTemplate: <
      P extends {
        category: string;
        entityType: string;
      }
    >(
      params: P
    ): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "uscservice",
            `domainmessages/${params.category}/${params.entityType}`,
            {},
            ServiceConfig()[`uscservice`]["domainMessage.template"]
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
    getFormattedTemplate: <P extends {} | {}[]>(params: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "uscservice",
            `domainmessageTexts`,
            params,
            ServiceConfig()[`uscservice`]["domainMessage.templateText"]
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
    getBasicInfo: <
      P extends {
        entityId: string;
        entityType: string;
      }
    >(
      params: P
    ): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "uscservice",
            `domainmessages/basicdata/${params.entityId}/${params.entityType}`,
            {},
            ServiceConfig()[`uscservice`]["domainMessage.basicInfo"]
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
    send: (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          let basicdata = {};

          const sendDomainMessageData = await versionedHttpCollection.post(
            "uscservice",
            "messages",
            params?.data,
            ServiceConfig()[`uscservice`]["domainMessage.send"]
          );

          if (sendDomainMessageData.data.isSuccess) {
            basicdata = await versionedHttpCollection.get(
              "uscservice",
              `domainmessages/basicdata/${params?.data.entityId}/${params?.data.entityType}`,
              {},
              ServiceConfig()[`uscservice`]["domainMessage.basicInfo"]
            );
          }

          resolve({
            sendDomainMessageData,
            basicdata,
          });
        } catch (error: any) {
          reject(error);
        }
      });
    },
    getText: <
      P extends {
        entityType: string;
      }
    >(
      params: P
    ): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "communicationservice",
            `texts/${params.entityType}`,
            {},
            "v1"
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
    getContent: <P extends {} | {}[]>(params: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.post(
            "activityservice",
            `dashboardmessage/content`,
            params,
            "v1"
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
    setDefaultTemplate: <P extends {} | {}[]>(params: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.post(
            "activityservice",
            `template/domainmessage`,
            params,
            "v1"
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
    sendMessage: <P extends {} | {}[]>(params: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.post(
            "activityservice",
            `dashboardmessage/message`,
            params,
            "v1"
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
  },

  printedDocument: {
    get: <P extends {} | {}[]>(params: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "activityservice",
            "activityhistory",
            params,
            ServiceConfig()[`activityservice`]["activityhistory"]
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
  },

  uploadedDocument: {
    get: <P extends {} | {}[]>(params: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "documentservice",
            "document/documentdetails",
            params,
            ServiceConfig()[`documentservice`]["uploaded.documents"]
          );
          if (status === 200) {
            resolve({ data, status });
          } else {
            reject({ data });
          }
        } catch (error: any) {
          reject(error);
        }
      });
    },
    upload: <P extends {} | {}[]>(params: P): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.uploadFile(
            "documentservice",
            "document",
            params,
            ServiceConfig()[`documentservice`]["document"]
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
    delete: <P>(params: P): Promise<{}> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.patch(
            "documentservice",
            "document",
            { documentId: params },
            ServiceConfig()[`documentservice`]["document"]
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
  },
  rules: {
    get: <
      P extends { entityId: number; type: string; propertyList: Array<string> }
    >(
      params: P
    ): Promise<{}> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "bmdservice",
            "bmds",
            { ...params, propertyList: params.propertyList.toString() },
            ServiceConfig()[`bmdservice`]["bmds"]
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
  },
  emailAttachmentContent: {
    get: <P extends {} | {}[]>(params: P): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "documentservice",
            "document",
            params,
            ServiceConfig()[`documentservice`]["document"]
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
  },
  dashboardTemplates: {
    get: <
      P extends {
        entityType: string;
      }
    >(
      params: P
    ): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await versionedHttpCollection.get(
            "uscservice",
            `templates/domainmessage/${params.entityType}`,
            {},
            "v1"
          );
          resolve({ data, status });
        } catch (error: any) {
          reject(error);
        }
      });
    },
  },
};
